import { getJson } from 'api/baseApi'

export const validate = function () {
  return getJson({ url: '/api/server/session/validate' })
}



// WEBPACK FOOTER //
// ./src/api/sessionApi.js